export default __webpack_public_path__ + "static/media/android.a552ef49.svg";